import { alertRequest, body } from "services/request";

const resource = "api/organizationEmployees";

const reject = (params: {}) => alertRequest(`${resource}/reject`, body(params));

const addUserRole = (params: {}) => alertRequest(`${resource}/addUserRole`, body(params));

const applyUser = (params: {}) => alertRequest(`${resource}/applyUser`, body(params));

const removeUserRole = (params: {}) => alertRequest(`${resource}/removeUserRole`, body(params));

export { reject, addUserRole, removeUserRole, applyUser };
